import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ContactlessIcon from "@mui/icons-material/Contactless";
import "./TpvCallButton.css";

/** Igual que el límite del backend (POST /tip/:id/solicitar-tpv). */
export const TPV_UBICACION_MAX_LENGTH = 40;

/**
 * "Pagar con el datáfono": avisa al camarero para que cobre la propina con la
 * app TPV. Opción secundaria, al mismo ancho que el botón de Google/Apple Pay.
 * Encima, un campo opcional para decir dónde está el cliente (mesa, terraza…):
 * `onClick` recibe ese texto ya recortado, o null si está vacío.
 */
const TpvCallButton = ({ onClick, disabled = false, fullWidth = false, accent = "#66bc5f" }) => {
  const { t } = useTranslation();
  const [ubicacion, setUbicacion] = useState("");

  const handleClick = () => {
    if (disabled) return;
    onClick(ubicacion.trim() || null);
  };

  return (
    <div
      className={`tpv-call${fullWidth ? " tpv-call--full" : ""}`}
      style={{ "--tpv-accent": accent }}
    >
      <input
        type="text"
        className="tpv-call__location"
        value={ubicacion}
        onChange={(e) => setUbicacion(e.target.value)}
        onKeyDown={(e) => {
          // Dentro de un <form> (pantalla de Stripe) Enter no debe enviar el pago
          if (e.key === "Enter") {
            e.preventDefault();
            handleClick();
          }
        }}
        maxLength={TPV_UBICACION_MAX_LENGTH}
        placeholder={t("tpvCall.ubicacionPlaceholder")}
        aria-label={t("tpvCall.ubicacionPlaceholder")}
        autoComplete="off"
        enterKeyHint="send"
        disabled={disabled}
      />
      <button
        type="button"
        className="tpv-call-button"
        onClick={handleClick}
        disabled={disabled}
      >
        <span className="tpv-call-button__icon" aria-hidden="true">
          <ContactlessIcon fontSize="small" />
        </span>
        <span className="tpv-call-button__text">
          <span className="tpv-call-button__title">{t("tpvCall.button")}</span>
          <span className="tpv-call-button__hint">{t("tpvCall.buttonHint")}</span>
        </span>
      </button>
    </div>
  );
};

export default TpvCallButton;
